import { RefObject, useEffect } from 'react';
import { useAppDispatch } from 'ducks/hooks';
import { ModalsState, setModal } from 'ducks/modals/slices';
import { UnionOfSingleKeyObjects } from 'ducks/types/type-helpers';

export const useOutsideClick = (ref: RefObject<HTMLElement>, handler: UnionOfSingleKeyObjects<ModalsState>) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && event.target instanceof HTMLElement && !ref.current.contains(event.target)) {
        const isOption = event.target.outerHTML.split(' ').find((el) => el === 'role="option"');
        if (!isOption) {
          dispatch(setModal(handler));
        }
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dispatch, handler, ref]);
};
